// extracted by mini-css-extract-plugin
export default {"paymentDatatable":"rT6XV","actionButtons":"bYLBT","table-header":"ch8NP"};